import { createContext, useContext } from "react";

import type {
  AirPlayControllerProviderProps,
  AirPlayControllerState
} from "./AirPlayController.types";

const unavailableState: AirPlayControllerState = {
  availableAudioTracks: [],
  beginScrubbing: () => {},
  currentIndex: 0,
  currentItemId: null,
  currentTime: 0,
  detachActivePlayback: () => false,
  duration: 0,
  endScrubbing: () => {},
  error: null,
  markCurrentItemReady: () => {},
  muted: false,
  next: async () => false,
  nowPlaying: null,
  playAfterScrubbing: () => {},
  player: null,
  playbackRate: 1,
  playing: false,
  previous: async () => false,
  progress: null,
  readyItemId: null,
  resumePlayback: () => {},
  routeActive: false,
  seek: () => {},
  selectedAudioTrack: null,
  setAudioTrack: () => {},
  setActivePlayback: () => {},
  setMuted: () => {},
  setPlaybackRate: () => {},
  setPlaying: () => {},
  togglePlaying: () => {}
};

const AirPlayControllerContext = createContext<AirPlayControllerState>(unavailableState);

export function AirPlayControllerProvider({ children }: AirPlayControllerProviderProps) {
  return (
    <AirPlayControllerContext.Provider value={unavailableState}>
      {children}
    </AirPlayControllerContext.Provider>
  );
}

export function useAirPlayController() {
  return useContext(AirPlayControllerContext);
}
